import React, { FunctionComponent, MouseEvent } from 'react';

import classnames from 'classnames';
import { Dropdown } from 'react-bootstrap';

import { ActionsMenu } from 'core/actions-menu/ActionsMenu';

import 'reviews2/feed/review-yeti/actions/ActionsMenu.scss';

interface Props {
    actions: DropdownAction[];
    actionFn: (event: MouseEvent<any>, action: DropdownAction) => void;
    isNorthStarEnabled?: boolean;
}

export interface DropdownAction {
    id: number | string;
    icon?: string;
    label: string;
}

export const ReviewActionsMenu: FunctionComponent<Props> = ({ actions, actionFn, isNorthStarEnabled }) => {
    if (!actions.length) {
        return null;
    }

    return (
        <div
            className={classnames('r4e-review-actions-menu', {
                'north-star': isNorthStarEnabled,
            })}
        >
            <ActionsMenu rotation={isNorthStarEnabled ? 'vertical' : 'horizontal'}>
                {actions.map((action) => {
                    return (
                        <Dropdown.Item
                            className={classnames({ [`dropdown-item-${action.icon}`]: true })}
                            key={action.id}
                            onClick={(event) => actionFn(event, action)}
                        >
                            <i className={action.icon} />
                            {action.label}
                        </Dropdown.Item>
                    );
                })}
            </ActionsMenu>
        </div>
    );
};
